/**
 * Check if the server error has a valid custom message
 * @param {number} code - The error code sent by the server
 * @param {string} message - The message sent by the server
 */
export default function customServerError(code, message) {
  const allowCodes = [30];
  if (allowCodes.find((errorCode) => errorCode === code)) return message;
}
